import { Components, Theme } from '@mui/material';

import { colors, palette } from '../colors';
import { fontFamily, pxToRem } from '../utils';

export const getMuiLink = (
    rootHtmlFontSize = 16
): Components<Theme>['MuiLink'] => ({
    styleOverrides: {
        root: {
            transition: 'color 0.3s ease',
            fontFamily,
            color: palette.text?.primary,
            fontWeight: 400,
            lineHeight: pxToRem(24, rootHtmlFontSize),
            textDecorationLine: 'underline',
            textDecorationColor: 'inherit',
            '&:hover': {
                color: colors.green[700],
            },
            '&:focus': {
                color: colors.green[900],
            },
            variants: [
                {
                    props: { color: 'primary.contrastText' },
                    style: {
                        '&:hover': { color: colors.neutral[300] },
                        '&:focus': { color: colors.neutral[500] },
                    },
                },
            ],
        },
    },
});
